import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import api from "../api/axiosConfig";
import { Autocomplete, TextField } from "@mui/material";
import PasswordInput from "./PasswordInput";
import "./RegisterPages.css";

const RegisterZonalHead = () => {
  const [formData, setFormData] = useState({
    name: "",
    username: "",
    email: "", // <-- FIX: Added email back to the state
    password: "Aionion@123",
    reports_to_id: "",
    reports_to_role: "director",
    location: "",
  });

  const [message, setMessage] = useState("");
  const [isError, setIsError] = useState(false);
  const [loading, setLoading] = useState(false);
  const [allDirectors, setAllDirectors] = useState([]);

  const navigate = useNavigate();
  const { directorId } = useParams();

  useEffect(() => {
    const fetchDirectors = async () => {
      try {
        const response = await api.get("/api/admin/directors");
        setAllDirectors(response.data || []);
      } catch (error) {
        console.error("Error fetching directors:", error);
        setMessage("Could not load list of Sales Heads.");
        setIsError(true);
      }
    };
    fetchDirectors();
  }, []);

  useEffect(() => {
    if (directorId) {
      setFormData((prev) => ({ ...prev, reports_to_id: Number(directorId) }));
    }
  }, [directorId]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage("");
    setIsError(false);

    try {
      const response = await api.post("/api/admin/register/zonal_head", {
        name: formData.name,
        username: formData.username,
        email: formData.email, // <-- FIX: Pass the email to the backend
        password: formData.password,
        location: formData.location,
        reports_to_id: formData.reports_to_id,
        reports_to_role: formData.reports_to_role,
      });

      setMessage(
        response.data.message || "Zonal Manager registered successfully!"
      );
      setIsError(false);

      setFormData({
        name: "",
        username: "",
        email: "", // <-- FIX: Reset the email field
        password: "Aionion@123",
        reports_to_id: "",
        reports_to_role: "director",
        location: "",
      });

      setTimeout(() => navigate("/admin-dashboard"), 2000);
    } catch (err) {
      console.error(err);
      setMessage(
        err.response?.data?.message || "Error registering Zonal Manager"
      );
      setIsError(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="register-form">
      <h2>Register Zonal Manager</h2>

      {message && (
        <div className={`alert ${isError ? "alert-danger" : "alert-success"}`}>
          {message}
        </div>
      )}

      <form onSubmit={handleSubmit}>
        <div className="mb-3">
          <label htmlFor="name" className="form-label">
            Name
          </label>
          <input
            type="text"
            className="form-control"
            id="name"
            name="name"
            value={formData.name}
            onChange={handleChange}
            required
            disabled={loading}
          />
        </div>

        <div className="mb-3">
          <label htmlFor="username" className="form-label">
            Username
          </label>
          <input
            type="text"
            className="form-control"
            id="username"
            name="username"
            value={formData.username}
            onChange={handleChange}
            required
            disabled={loading}
          />
        </div>

        {/* --- FIX: ADDED THE MISSING EMAIL INPUT FIELD --- */}
        <div className="mb-3">
          <label htmlFor="email" className="form-label">
            Email (Optional)
          </label>
          <input
            type="email"
            className="form-control"
            id="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            disabled={loading}
          />
        </div>

        <PasswordInput
          label="Password"
          name="password"
          value={formData.password}
          onChange={handleChange}
          required
          disabled={loading}
        />

        <div className="mb-3">
          <label htmlFor="location" className="form-label">
            Location
          </label>
          <select
            className="form-select"
            id="location"
            name="location"
            value={formData.location}
            onChange={handleChange}
            required
            disabled={loading}
          >
            <option value="">Select Location</option>
            <option value="Chennai">Chennai</option>
            <option value="Trichy">Trichy</option>
            <option value="Coimbatore">Coimbatore</option>
            <option value="Bangalore">Bangalore</option>
            <option value="Dubai">Dubai</option>
            <option value="Singapore">Singapore</option>
            <option value="Madurai">Madurai</option>
          </select>
        </div>

        <div className="mb-3">
          <label htmlFor="director_id" className="form-label">
            Assign Sales Head (Director)
          </label>
          <Autocomplete
            options={allDirectors}
            getOptionLabel={(option) => option.name}
            value={
              allDirectors.find((d) => d.id === Number(formData.reports_to_id)) ||
              null
            }
            onChange={(event, newValue) => {
              setFormData({
                ...formData,
                reports_to_id: newValue ? newValue.id : "",
              });
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                placeholder="Search and select Sales Head..."
                variant="outlined"
                required
              />
            )}
            disabled={loading}
          />
        </div>

        <div className="btn-container">
          <button type="submit" className="btn btn-primary" disabled={loading}>
            {loading ? "Registering..." : "Register Zonal Manager"}
          </button>
          <button
            type="button"
            className="btn btn-secondary"
            onClick={() => navigate("/admin-dashboard")}
            disabled={loading}
          >
            Back to Dashboard
          </button>
        </div>
      </form>
    </div>
  );
};

export default RegisterZonalHead;
